var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "starter-page page-landing",
      on: {
        dblclick: function ($event) {
          return _vm.handleDblClick()
        },
      },
    },
    [
      _vm.demoProjects
        ? _c("Gantt", {
            attrs: {
              vie: "",
              tasks: _vm.demoProjects,
              "show-billing": _vm.showBilling,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }